import './temas.css';
import { isMarketingDomain } from '@/lib/domain';
import { heredarEnLasCapas } from './capas';
import { aplicarPreferencia, conHerramientasDePrueba, leerPreferencia } from './tema';

/**
 * La piel de Smarty. Se llama una vez al arrancar (main.tsx), antes del primer render.
 *
 * Aplica la piel elegida (por defecto Nítido con la marca Clásico) y monta el modal «Apariencia», que se
 * abre desde el menú de la cuenta y el de Chats. Con la bandera de prueba (VITE_TEMAS_PRUEBA=1 o
 * localStorage «smarty.tema.probar» = «1») monta además el botón flotante del equipo con el revisor.
 *
 * 🪤 temas.css VA ESTÁTICO: con `import()` llegaba después del primer pintado y la pantalla salía un
 *    instante con los colores de Polaris antes de tomar la piel.
 *
 * 🔒 EN LA LANDING DE MARKETING NO HACE NADA: es otra página (sin Polaris) que sirve este mismo arranque, y la
 *    piel no tiene por qué tocarle el modo claro/oscuro. La tienda pública ya no pasa por acá (la sirve el Worker).
 */
export function iniciarTema(): void {
  if (isMarketingDomain()) return;
  heredarEnLasCapas();
  aplicarPreferencia(leerPreferencia());
  void import('./montarApariencia').then((m) => m.montarApariencia());
  if (conHerramientasDePrueba()) void import('./montarSelector').then((m) => m.montarSelectorDeTema());
}
